<template>
	<div class="custom-upload">
		<el-upload :action="url()" :accept="$attrs.accept || all_suffix" list-type="list" :before-upload="before"
			 :show-file-list="false"
			:on-change="
                (file, fileList) => {
                    change(file);
                }
            " :before-remove="
                (file, fileList) => {
                    return before_remove(file);
                }
            " :file-list="fileList" v-bind="$attrs">
			<slot v-for="(_, slotName) in $slots" :name="slotName" :slot="slotName" />
			<template v-for="(_, scopeSlotName) in $scopedSlots" #[scopeSlotName]="scope">
				<slot :name="scopeSlotName" v-bind="scope" />
			</template>
		</el-upload>
	</div>
</template>

<script>
	function getMediaDuration(fileUrl) {
		return new Promise((resolve, reject) => {
			let audioElement = new Audio(fileUrl); //audio也可获取视频的时长
			audioElement.addEventListener("loadedmetadata", function(_event) {
				let duration = parseInt(audioElement.duration);
				resolve(duration)
			});
		})
	}
	import axios from "axios";
	export default {
		name: "custom-upload",
		inheritAttrs: false,
		props: {
			fileList: {
				type: [Array, null],
				default: () => []
			},
			onlyUpload: Boolean
		},
		data() {
			return {
				preview_url: "",
				fileShow: false,
				preview_visible: false,
				document_suffix: ".txt,.doc,.docx,.xls,.xlsx,.pdf",
				image_suffix: ".jpg,.png,.gif,.bmp",
				all_suffix: ".txt,.doc,.xls,.ppt,.pdf,.jpg,.png,.gif,.bmp,.docx,.xlsx,.pptx,.mp4,.avi,.mov",
			};
		},
		methods: {
			url: function() {
				var API_UPLOAD_URL = process.env.API_UPLOAD_URL;
				return API_UPLOAD_URL;
			},
			before() {
				return false;
			},
			before_remove(file) {
				var that = this;
				if (file && file.status === "success") {
					return this.$confirm(
						`确定移除 ${file.name}？`,
						"提示", {}
					).then(
						() => {
							that.remove(file);
							return reject(false);
						},
						() => {
							reject(false);
						} //取消 时的处理
					);
				}
			},
			remove(file) {
				if (file && file.status === "success") {
					let index = this.fileList.findIndex(item => file.url == item.url);
					this.fileList.splice(index, 1);
				}
				return false;
			},
			async change(file) {
				var that = this;
				const loading = this.$loading({
					lock: true,
					text: "上传中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)",
				});
				//文件大小验证开始 如果要加上文件大小验证，加上此段代码
				let fileSize = file.size / 1024 / 1024;
				let MaxFileSize = 20
				if (fileSize > MaxFileSize) {
					this.$message.error(
						"上传的文件过大，请压缩至" + MaxFileSize + "M之内再进行上传"
					);
					loading.close();
					return false;
				}
				// 文件大小验证结束
				if (file && file.status === "ready") {
					let formData = new FormData();
					formData.set("file", file.raw);
					try {
						let config = {
							headers: {
								"Content-type": "multipart/form-data",
							},
						};
						const res = await axios.post(that.url(), formData, config);
						if (res.status == 200 && res.data.status == 2000) {
							if (res.data.errors.length) {
								this.$message.error(
									"上传失败," + res.data.errors[0].error
								);
							} else {
								for (let i = 0; i < res.data.files.length; i++) {
									let item = res.data.files[i];
									if (/mp3|mp4/.test(item.ext)) {
										item.duration = await getMediaDuration(item.url);
									}
								}
								this.fileList.push(...res.data.files);
								this.$emit('change', this.fileList);
								if (this.onlyUpload) {
									this.fileList.splice(0, 1);
								}
							}
						}
					} catch (ex) {
						this.$message.error("网络异常，请稍后重试");
					}
					loading.close();
				}
				return false;
			},
			preview(file) {
				window.open(file.viewurl);
				this.fileShow = true;
				this.preview_url = file.url;
				this.preview_visible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/custom-upload.vue